module.exports = __webpack_public_path__ + "img/verifiedIcon.38df4c1a.png";